import './Admin.scss';
import { Routes, Route } from 'react-router-dom';
import Main from './Main';
import Login from './Login';
import EditMainInfo from './edit/EditMainInfo';
import EditGallery from './edit/EditGallery';
import EditPractice from './edit/EditPractice';
import Backup from './Backup';
import EditPopup from './edit/EditPopup';
import AdminLayout from './AdminLayout';


export default function AdminMain( props: any) {

  return (
    <Routes>
      <Route path="/" element={<Login/>}/>
      <Route element={<AdminLayout/>}>
        <Route path="/main" element={<Main/>}/>
        <Route path="/edit/main-info" element={<EditMainInfo/>}/>
        <Route path="/edit/gallery" element={<EditGallery/>}/>
        <Route path="/edit/support-practice" element={<EditPractice/>}/>
        <Route path="/edit/popup" element={<EditPopup/>}/>
        <Route path="/backup" element={<Backup/>}/>
      </Route>
    </Routes>
  );
}
